import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import sharedPropsService from "../../SharedPropsService";
import { ROUTE } from "../../routes";
export const navigation = async (action, _datastore, { navigate }) => {
    console.warn("*** navigationAction props ***", action);
    const routeId = action.payload.routeId;
    await navigate(routeId);
};
export const goBack = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const updateStateAction = async (action, _datastore, { navigate, network }) => {
    const stateValue = action.payload.stateValue;
    if (stateValue) {
        const user = await sharedPropsService.getUser();
        const creditApplicationId = user?.linkedApplications[0]?.applicationId;
        const stateUpdateResponse = await network.post(`${api.resetStateLoanRegistration}`, {
            creditApplicationId: `${creditApplicationId}`,
            stampDutyState: `${stateValue}`
        }, {
            headers: await getAppHeader()
        });
        if (stateUpdateResponse.status === 200) {
            navigate(ROUTE.PLEDGE_CONFIRMATION, { skipPledgeInProgressCheck: true });
        }
    }
    navigate(ROUTE.PLEDGE_CONFIRMATION, { skipPledgeInProgressCheck: true });
};
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
